<template>
  <dara-single-content-layout container-size="xl">
    <template #content>
      <dara-row>
        <dara-col :xs="24" :span="16">
          <slot name="center" />
        </dara-col>
        <dara-col :xs="24" :span="8">
          <slot name="right" />
        </dara-col>
      </dara-row>
    </template>
  </dara-single-content-layout>
</template>
<script>
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraArticleLayout',
  components: {
    DaraSingleContentLayout,
  },
};
</script>
